import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 航线产品
export function queryAirlineProducts(data) {
  return request({
    url: URL.booking.airExport.queryAirlineProducts,
    method: 'post',
    data
  })
}

// 航线产品
export function detailAirlineProduct(data) {
  return request({
    url: URL.booking.airExport.detailAirlineProduct,
    method: 'post',
    data
  })
}

// 保存航线产品
export function saveAirlineProduct(data) {
  return request({
    url: URL.booking.airExport.saveAirlineProduct,
    method: 'post',
    data
  })
}

// 删除航线产品
export function deleteAirlineProduct(data) {
  return request({
    url: URL.booking.airExport.deleteAirlineProduct,
    method: 'delete',
    data
  })
}

// 查询航线产品下拉
export function queryAirlineProductDownList(data) {
  return request({
    url: URL.booking.airExport.queryAirlineProductDownList,
    method: 'post',
    data
  })
}
